import { useShallow } from 'zustand/react/shallow';
import { useMaestroStore } from '../store/maestroStore';

/** Flat primitive snapshot — never nest objects in useShallow selectors (React #185). */
function useNowPlayingSnapshot() {
  return useMaestroStore(
    useShallow((s) => {
      const t = s.currentTrack;
      if (!t || s.playbackState === 'stopped') {
        return {
          albumId: '',
          albumTitle: '',
          artistName: '',
          playbackActive: false,
        };
      }
      return {
        albumId: String(t.albumId || t.album_id || t.serviceAlbumId || ''),
        albumTitle: (t.album || t.albumTitle || '').toLowerCase().trim(),
        artistName: (t.artist || t.artistName || '').toLowerCase().trim(),
        playbackActive: s.playbackState === 'playing' || s.playbackState === 'loading',
      };
    }),
  );
}

export function albumMatchesNowPlaying(album, npKey) {
  if (!npKey || !album) return false;
  const id = String(album?.id || album?.album_key || album?.serviceAlbumId || '');
  if (npKey.albumId && id && npKey.albumId === id) return true;
  const title = (album?.title || album?.album || '').toLowerCase().trim();
  const artist = (
    album?.artist?.name
    || album?.artistName
    || album?.artist_name
    || album?.album_artist
    || album?.artist
    || ''
  ).toLowerCase().trim();
  return !!(title && artist && title === npKey.albumTitle && artist === npKey.artistName);
}

export function useAlbumTilePlayback(album) {
  const snap = useNowPlayingSnapshot();
  const isActive = albumMatchesNowPlaying(album, snap);
  return {
    isActive,
    isPlaying: isActive && snap.playbackActive,
  };
}

export function usePlaybackActive() {
  return useMaestroStore(
    (s) => s.playbackState === 'playing' || s.playbackState === 'loading',
  );
}
